module.exports = __webpack_public_path__ + "img/arrow2.f8fde48b.svg";